import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { getDatasourceDetailInfo, openBlankWindow, replaceDatasourceIdWithConnectionIdForMixedContent } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { Messages } from '../../codegen/Localize';
import { ContentActionsService } from '../../commonInfra/contentActions/ContentActions';
import { IDataSourceDetailInfo } from '../../datasource/models/IDataSourceInfo';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { NewMetricForDatasourceAction } from '../actions/NewMetricForDatasourceAction';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards

export function* handleNewMetricForDatasourceAction(action: NewMetricForDatasourceAction): SagaIterator {
  if (!FeatureFlags.metricsAuthoringPathEnabled) {
    return;
  }
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    const mutableContentInfo: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
    const datasourceDetailInfo = yield call(getDatasourceDetailInfo, mutableContentInfo[0].id);
    createNewMetricForDatasource(datasourceDetailInfo, newWindow);
  } catch(e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function createNewMetricForDatasource(datasourceDetailInfo: IDataSourceDetailInfo, newWindow: Window) {
  const sessionManagementService = getSessionManagementServiceInstance();
  newWindow.location.href = ContentActionsService.generateNewMetricForDatasourceUrl(datasourceDetailInfo, sessionManagementService.sessionSiteUrlName());
}
